import React, { FC } from 'react';

interface Props {
  if: boolean;
  children?: React.ReactNode;
}

const Render: FC<Props> = ({ if: show, children }) => {
  return <>{show ? children : null}</>;
};

export default Render;
